module.exports = __webpack_public_path__ + "static/img/329d9728910685497e1839fb2114c844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youshi_jkfh.png
// module id = nS+t
// module chunks = 1